import { NgModule } from "@angular/core";
import { provideRouter, RouterModule, Routes, withDebugTracing } from "@angular/router";
import { HomeComponent } from "./components/common/home/home.component";
import { StyleGuideComponent } from "./components/layout/style-guide/style-guide.component";
import { authGuard } from "src/app/auth/auth-guard.service";
import { CreateLeadComponent } from "../recruiting/create-lead/create-lead.component";
import { TeamsRegisteredComponent } from "../recruiting/teams-registered/teams-registered.component";
import { PromoCodesComponent } from "../recruiting/promo-codes/promo-codes.component";
import { LeadSearchComponent } from "../recruiting/lead-search/lead-search.component";
import { RecruitingDashboardComponent } from "./components/departments/recruiting/dashboard/recruiting-dashboard.component";
import { WebLeadsComponent } from "../recruiting/web-leads/web-leads.component";
import { PTripsComponent } from "../recruiting/p-trips/p-trips.component";
import { GlParticipantSurveyComponent } from "../trips/gl-participant-survey/gl-participant-survey.component";
import { RemoveOldCallsMainComponent } from "../tools/remove-old-calls-main/remove-old-calls-main.component";
import { DeleteRecordComponent } from "../tools/delete-record/delete-record.component";
import { ReportsComponent } from "../tools/reports/reports.component";
import {SeasonalStaffingComponent} from "../tools/seasonal-staffing/seasonal-staffing.component";
import { MyActivitiesComponent } from "./components/common/my-activities/my-activities.component";
import { MergeRecordsComponent } from "../tools/merge-records/merge-records.component";
import { PhotoboothApprovalComponent } from "./components/common/photobooth-approval/photobooth-approval.component";

const routes: Routes = [
    // before "" so marketing/it are not blocked by default fullsite metadata
    {
      path: "photobooth/approve",
      component: PhotoboothApprovalComponent,
      canActivate: [authGuard(['marketing', 'it'])],
      title: "Photobooth Approval | Mission Control",
    },
    {
      path: "",
      canActivate: [authGuard()],
      children: [
        {path: "", component: HomeComponent, title: "Mission Control" },
        {path: "style-guide", component: StyleGuideComponent, canActivate: [authGuard(['it'])], title: "Style Guide" },
        {path:"new-lead", component: CreateLeadComponent, title: "New Lead"},
        {path: "my-activities", component: MyActivitiesComponent, title: "My Activities"}
      ]
    },
    {
      path: "recruiting",
      canActivate: [authGuard(['sales', 'admin'])],
      children: [
        {path: "dashboard", component: RecruitingDashboardComponent, title: "Recruiting Dashboard | Mission Control" },
        {path: "teams-registered", component: TeamsRegisteredComponent, title: "Teams Registered | Mission Control"},
        {path: "promo-codes", canActivate: [authGuard(['it', 'salesAdmin'])], component: PromoCodesComponent, title: "Promo Codes | Mission Control"},
        {path: "lead-search", component: LeadSearchComponent, title: "Lead Search | Mission Control"},
        {path: "web-leads", canActivate: [authGuard(['salesAdmin'])], component: WebLeadsComponent, title: "Web Leads | Mission Control"},
        {path: "pTrips", component: PTripsComponent, title: "P Trips | Mission Control"}
      ]
    },
    {
      path: "trips",
      canActivate: [authGuard()],
      children: [
        {path: "surveys", canActivate: [authGuard(['ft'])], component: GlParticipantSurveyComponent, title: "Surveys | Mission Control"}
      ]
    },
    {
      path: "tools",
      children: [
        { path: "remove-old-calls", canActivate: [authGuard()], component: RemoveOldCallsMainComponent, title: "Remove Old Calls | Mission Control" },
        { path: "delete-record", canActivate: [authGuard(['admin'])], component: DeleteRecordComponent, title: "Delete Record | Mission Control" },
        { path: "reports", canActivate: [authGuard()], component: ReportsComponent, title: "Reports | Mission Control" },
        { path: "merge-records", canActivate: [authGuard()], component: MergeRecordsComponent, title: "Merge Records | Mission Control" },
        {
          path: "photobooth",
          loadComponent: () => import('../mc-hosted/photobooth/photobooth.component').then(m => m.PhotoboothComponent),
          title: "Photobooth | Mission Control",
        },
      ],
    },
    {
      path: 'hr',
      canActivate: [authGuard()],
      children: [
        {path: "seasonal-staffing", component: SeasonalStaffingComponent, title: "Seasonal Staffing | Mission Control"}
      ]
    },
    {
      path: 'ppm365',
      loadChildren: () => import('../ppm365/ppm365.module').then(m => m.Ppm365Module)
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class MissionControlRoutingModule { }
  